import { SIZE } from "../../../../constants/field-size"
import { FIELDTYPE } from "../../../../constants/field-type"

export const DB_fieldName = "Fields"

export const fieldName2 = {
    fieldType:"fieldType",
    fieldName:"fieldName",
    fieldName2:"fieldName2",
    fieldOrder:"fieldOrder",
    fieldSection:"fieldSection",
    fieldSize:"fieldSize",
    fieldOptions:"fieldOptions",
    description:"description",
    showDescription:"showDescription",
    isRequired:"isRequired",
    formula:"formula",
    disabled:"disabled",
}

export const formFields = [
    { label: "Field Type", size: SIZE.M, fieldVal: fieldName2.fieldType, fieldType: FIELDTYPE.DROP_DOWN, options: [FIELDTYPE.TEXT, FIELDTYPE.NUMBER, FIELDTYPE.CURRENCY,FIELDTYPE.SINGLE_SELECT, FIELDTYPE.DROP_DOWN, FIELDTYPE.MULTI_SELECT, FIELDTYPE.LONG_TEXT, FIELDTYPE.DATE, FIELDTYPE.RADIO, FIELDTYPE.DIVIDER] },
    { label: "Field Name", size: SIZE.M, fieldVal: fieldName2.fieldName, fieldType: FIELDTYPE.TEXT },
    { label: "Field Section", size: SIZE.M, fieldVal: fieldName2.fieldSection, fieldType: FIELDTYPE.NUMBER, type: "Number" },
    { label: "Field Order", size: SIZE.M, fieldVal: fieldName2.fieldOrder, fieldType: FIELDTYPE.NUMBER, type: "Number" },
    { label: "Field Size", size: SIZE.M, fieldVal: fieldName2.fieldSize, fieldType: FIELDTYPE.DROP_DOWN, options: [SIZE.XS, SIZE.S, SIZE.M, SIZE.L, SIZE.XL, SIZE.XXL] },
    { label: "Field Options", size: SIZE.M, fieldVal: fieldName2.fieldOptions, fieldType: FIELDTYPE.TEXT , withInfo: true , description:"Please separate each option with a comma. E.g. Banana, Apple, Mango" },
    { label: "Description", size: SIZE.L, fieldVal: fieldName2.description, fieldType: FIELDTYPE.LONG_TEXT },
    { label: "Show Description?", size: SIZE.S, fieldVal: fieldName2.showDescription, fieldType: FIELDTYPE.RADIO, options: ["Yes", "No"] },
    { label: "Required?", size: SIZE.S, fieldVal: fieldName2.isRequired, fieldType: FIELDTYPE.RADIO, options: ["Yes", "No"] },
    { label: "Disabled", size: SIZE.S, fieldVal: fieldName2.disabled, fieldType: FIELDTYPE.RADIO, options: ["Yes", "No"] },
    { label: "Formula", size: SIZE.L, fieldVal: fieldName2.formula, fieldType: FIELDTYPE.LONG_TEXT ,  withInfo: true , description:"For auto calculate field e.g()" },
]

export const tbColumns = [
    { id: fieldName2.fieldType, label: 'Field Type', minWidth: 50 },
    { id: fieldName2.fieldName, label: 'Field Name', minWidth: 130, maxWidth: 150 },
    { id: fieldName2.fieldName2, label: 'Field Name2', minWidth: 130, maxWidth: 150 },
    { id: fieldName2.fieldSection, label: 'Field Section', minWidth: 50 },
    { id: fieldName2.fieldOrder, label: 'Field Order', minWidth: 50 },
    { id: fieldName2.fieldSize, label: 'Field Size', minWidth: 50 },
    { id: fieldName2.fieldOptions, label: 'Field Options', minWidth: 50 },
    { id: fieldName2.description, label: 'Description', minWidth: 50 },
    { id: fieldName2.showDescription, label: 'Show Description?', minWidth: 50 },
    { id: fieldName2.isRequired, label: 'Required?', minWidth: 50 },
    { id: fieldName2.disabled, label: 'Disabled', minWidth: 50 },
    { id: fieldName2.formula, label: 'Formula', minWidth: 50 },
    { id: 'action', label: 'Action', minWidth: 50 }
]